import { z } from 'zod';
import { InvalidArgumentError } from '@commander-js/extra-typings';
import { docsExtensionTypeSchema } from '../components/GenerateCommand/docsExtensionType.js';

export function validateSite(value: string) {
  const parsed = z
    .union([z.string().uuid(), z.literal('current')])
    .transform((val) => (val === 'current' ? undefined : val))
    .safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be a valid GUID or "current"');
}

export function validateBase(value: string) {
  const parsed = z.string().url().safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be a valid URL');
}

export function validateDocsExtensionType(value: string) {
  const parsed = docsExtensionTypeSchema.safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be a valid extension type');
}

export function validateVersion(value: string) {
  const parsed = z
    .string()
    .regex(/^(0|[1-9]\d*)\.(0|[1-9]\d*)(\.(0|[1-9]\d*))?$/)
    .safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError(
    'Version value should be in semver format `x.x.x`'
  );
}

export function validateReleaseComment(value: string) {
  const parsed = z.string().max(250).optional().safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError(
    'The comment is limited to a maximum of 250 characters'
  );
}
